<template>
  <div class="">
    <Page :title="pageTitle">
      <div class="">
        <div>
          <div
            class="Polaris-Box"
            style="--pc-box-border-block-end:var(--p-border-divider);--pc-box-padding-inline-start-xs:var(--p-space-2);--pc-box-padding-inline-end-xs:var(--p-space-2)"
          >
            <ul role="tablist" class="Polaris-Tabs">
              <li
                v-for="(tab, index) of tabs"
                :key="index"
                class="Polaris-Tabs__TabContainer"
                role="presentation"
              >
                <router-link
                  role="tab"
                  :to="{ name: tab.routeName }"
                  type="button"
                  tabindex="0"
                  class="Polaris-Tabs__Tab"
                  exact-active-class="Polaris-Tabs__Tab--selected"
                  aria-selected="true"
                  aria-controls="all-customers-content-1"
                  aria-label="All customers"
                >
                  <span class="Polaris-Tabs__Title">{{ tab.label }}</span>
                </router-link>
              </li>
            </ul>
          </div>
          <div
            class="Polaris-Tabs__Panel"
            id="all-customers-content-1"
            role="tabpanel"
            aria-labelledby="all-customers-1"
            tabindex="-1"
          >
            <div class="Polaris-LegacyCard__Section">
              <router-view></router-view>
            </div>
          </div>
        </div>
      </div>
    </Page>
  </div>
</template>

<script>
import Page from "../../components/Common/Page";

export default {
  components: {
    Page
  },
  data() {
    return {
      pageTitle: "Chat & Share",
      tabs: [
        {
          label: "Chat",
          routeName: "ChatConfigure"
        },
        {
          label: "Share",
          routeName: "ShareConfigure"
        },
        {
          label: "Other Settings",
          routeName: "ChatOtherSettings"
        },
        {
          label: "CRM",
          routeName: "CRM"
        },

      ]
    };
  }
};
</script>

<style lang="scss" scoped></style>
